import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-950/95 backdrop-blur-md shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-ancient-gate-line text-primary-500 text-2xl"></i>
            </span>
            <span className="text-xl font-bold font-heading text-foreground-100">
              风车动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === "/"
                  ? "text-primary-500"
                  : "text-foreground-300 hover:text-primary-400"
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname.startsWith("/category")
                    ? "text-primary-500"
                    : "text-foreground-300 hover:text-primary-400"
                }`}
              >
                分类浏览
                <span className="w-4 h-4 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-xs transition-transform ${
                      categoryOpen ? "rotate-180" : ""
                    }`}
                  ></i>
                </span>
              </button>

              {categoryOpen && (
                <div className="absolute top-full mt-2 left-0 bg-background-800 border border-background-600/50 rounded-lg py-2 w-48 shadow-xl z-50 animate-fade-in">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-300 hover:text-primary-400 hover:bg-background-700/50 whitespace-nowrap cursor-pointer transition-colors"
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </span>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === "/about"
                  ? "text-primary-500"
                  : "text-foreground-300 hover:text-primary-400"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/80 text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-search-line"></i>
            </button>
            <button className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-all hover:scale-105">
              开始追番
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-300 cursor-pointer"
          >
            <i
              className={`text-xl ${
                mobileOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-700/50 pt-4 animate-fade-in">
            <Link
              to="/"
              className="block py-3 text-sm font-medium text-foreground-300 hover:text-primary-400 whitespace-nowrap cursor-pointer"
            >
              首页
            </Link>
            <div className="py-2">
              <p className="text-xs text-foreground-500 mb-2">分类浏览</p>
              <div className="grid grid-cols-2 gap-1">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-2 py-2 text-sm text-foreground-400 hover:text-primary-400 whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className="block py-3 text-sm font-medium text-foreground-300 hover:text-primary-400 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
            <button className="mt-3 w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-all">
              开始追番
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}